"use client";
import { FC } from "react";
import { CHAR_LIMITS, textEllipsis } from "./clpCardConstant";
import { PriceChangeProps } from "./types";

export const PriceChange: FC<PriceChangeProps> = ({
  changePrice,
  perChange,
}) => {
  const combined = `${changePrice} (${Number(perChange).toFixed(2)}%)`;
  return (
    <p className="stock-change-info mt-1 text-[12px] leading-[1.333] text-[#666]">
      {textEllipsis(
        combined,
        CHAR_LIMITS.TOTAL_CHANGE_INFO,
        "stock-change-info",
      )}
    </p>
  );
};

